const parseLocationIds = (value?: string) =>
  (value ?? '')
    .split(',')
    .map(id => id.trim())
    .filter(Boolean);

// Enabled globally and, where an allowlist is configured, for that location. Empty list = all.
const createLocationFlag =
  (
    globalFlag?: string,
    allowedLocations?: string,
    { globalWhenStoreUnknown = false } = {},
  ) =>
  (shortName?: string | null): boolean => {
    const allowedGlobally = (globalFlag ?? 'false') === 'true';

    if (!shortName && globalWhenStoreUnknown) {
      return allowedGlobally;
    }

    const locations = parseLocationIds(allowedLocations);

    return (
      allowedGlobally &&
      (!locations.length || (!!shortName && locations.includes(shortName)))
    );
  };

export const isCurbsideAllowedForStore = createLocationFlag(
  process.env.NEXT_PUBLIC_FEATURE_FLAG_ALLOW_CURBSIDE_PICKUP,
  process.env.NEXT_PUBLIC_FEATURE_FLAG_ALLOWED_CURBSIDE_PICKUP_LOCATIONS,
);

export const isGuestCheckoutAllowedForStore = createLocationFlag(
  process.env.NEXT_PUBLIC_ALLOW_GUEST_CHECKOUT,
  process.env.NEXT_PUBLIC_FEATURE_FLAG_ALLOWED_GUEST_CHECKOUT_LOCATIONS,
);

export const isMedAndRecSelectionActiveForStore = createLocationFlag(
  process.env.NEXT_PUBLIC_FEATURE_FLAG_MED_REC_SELECTION_ACTIVE,
  process.env.NEXT_PUBLIC_FEATURE_FLAG_ACTIVE_MED_AND_REC_SELECTION_LOCATIONS,
);

export const isMedicalDocumentRequiredForStore = createLocationFlag(
  process.env.NEXT_PUBLIC_FEATURE_FLAG_MEDICAL_DOCUMENT_REQUIRED,
  process.env.NEXT_PUBLIC_FEATURE_FLAG_REQUIRED_MEDICAL_DOCUMENT_LOCATIONS,
);

export const isMedicalSignUpAllowedForStore = createLocationFlag(
  process.env.NEXT_PUBLIC_FEATURE_FLAG_ALLOW_MEDICAL_SIGN_UPS,
  process.env.NEXT_PUBLIC_FEATURE_FLAG_ALLOWED_MEDICAL_SIGN_UP_LOCATIONS,
  { globalWhenStoreUnknown: true },
);
